"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function jobs(_ref) {
  var jobService = _ref.jobService;
  return {
    name: 'jobs',
    synopsis: 'jobs',
    description: 'List jobs and their statuses',
    format: function format(output) {
      return output.map(jobToString).join('\n\n');
    },
    execute: function execute(args) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _args, userId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(args.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return jobService.list();

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
                _args = _slicedToArray(args, 1), userId = _args[0];
                _context.next = 7;
                return jobService.find({
                  userId: userId
                });

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
}

var jobToString = function jobToString(_ref2) {
  var id = _ref2.id,
      userId = _ref2.userId,
      status = _ref2.status,
      started = _ref2.started,
      finished = _ref2.finished,
      source = _ref2.source,
      command = _ref2.command;
  var baseString = ["ID: ".concat(id), "PID: ".concat(command.pid), "Invoker ID: ".concat(userId), "Status: ".concat(status), "Started: ".concat(started), "Source: ".concat(source)];
  return (finished ? baseString.concat(["Finished: ".concat(finished)]) : baseString).join('\n');
};

var _default = jobs;
exports.default = _default;